import { EColors, EFonts } from 'libs/styles/styling';
import styled from 'styled-components/macro';

interface Props {
    size?: number;
    images: string[];
    className?: string;
    onClick?: () => void;
}

export const ImageValuesPreview = (props: Props): JSX.Element => {
    return (
        <S_ImageValuesPreview className={props.className} onClick={props.onClick}>
            {props.images.map((image) => {
                return <S_Image $src={image} $size={props.size} key={image} />;
            })}
        </S_ImageValuesPreview>
    );
};

const S_ImageValuesPreview = styled.div`
    font-size: 13px;
    color: ${EColors.DARK};
    font-family: ${EFonts.Regular};
    padding: 10px 10px 5px 10px;
    border-bottom: 1px solid #dadada;
    display: flex;
    flex-wrap: wrap;
`;

const S_Image = styled.div<{ $src: string; $size?: number }>`
    width: ${(props) => props.$size || 40}px;
    height: ${(props) => props.$size || 40}px;
    border-radius: 7px;
    background-image: url(${(props) => props.$src});
    background-size: cover;
    background-position: center;
    border: 1px solid #dadada;
    margin: 0 5px 5px 0;
`;
